import { render, staticRenderFns } from "./BrandmeIaBanner.vue?vue&type=template&id=0c2cc4ef&scoped=true&"
import script from "./BrandmeIaBanner.vue?vue&type=script&lang=js&"
export * from "./BrandmeIaBanner.vue?vue&type=script&lang=js&"
import style0 from "./BrandmeIaBanner.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BrandmeIaBanner.vue?vue&type=style&index=1&id=0c2cc4ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2cc4ef",
  null
  
)

export default component.exports